import event from './event'

export default event
